var React = require('react');

function LogoT (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#393939","fillRule":"evenodd","d":"M9.01 9.656v2.417h1.21V15.7c.095 2.966 1.725 3.584 3.626 3.788 1.105-.055 2.459-.464 3.143-1.008v-2.055c-.88.856-3.243 1.695-3.667-.725l-.04-3.667 3.707.04V9.617h-3.707l.08-3.103-1.49.04c.102 2.646-1.304 3-2.861 3.103zM13 26C5.82 26 0 20.18 0 13S5.82 0 13 0s13 5.82 13 13-5.82 13-13 13z"}));
}

LogoT.defaultProps = {"width":"26","height":"26","viewBox":"0 0 26 26"};

module.exports = LogoT;

LogoT.default = LogoT;
